import {
  EmploymentInformation,
  Person,
  User,
  UserHistorySchema,
  UserSchema,
} from 'packages/lib/api/annotations-ops/contract';
import { operationsClient } from 'packages/lib/api/annotations-ops/http-client';
import z from 'zod';

export const usersApi = {
  list: () => {
    return operationsClient.get('/roster-management/users', {
      schema: z.array(UserSchema),
    });
  },
  getCurrent: () => {
    return operationsClient.get('/roster-management/users/me', {
      schema: UserSchema,
    });
  },
  syncFromOkta: () => {
    return operationsClient.get('/roster-management/users/sync');
  },
  update: (userId: string, body: Partial<User>) => {
    return operationsClient.put(`/roster-management/users/${userId}`, {
      body,
      schema: UserSchema,
    });
  },
  add: (body: Person & EmploymentInformation) => {
    return operationsClient.post('/roster-management/users', {
      body,
      schema: UserSchema,
    });
  },
  addBulk: (body: (Person & EmploymentInformation)[]) => {
    return operationsClient.post('/roster-management/users/bulk-import', {
      body,
      schema: z.array(UserSchema),
    });
  },
  history: {
    get: (userId: string) => {
      return operationsClient.get(
        `/roster-management/users/${userId}/history`,
        {
          schema: z.array(UserHistorySchema),
        }
      );
    },
  },
};
